"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RetrieveCartState = /** @class */ (function () {
    function RetrieveCartState() {
        this.showModal = false;
        this.isEmailinValid = false;
        this.email = '';
        this.emailErrTxt = '';
        this.isSubmitBtnDisabled = true;
        this.emailUpdated = false;
        this.canBeCollapsed = false;
        this.errorMsg = '';
        this.retrieveCartApiIsError = false;
        this.currentValue = '';
    }
    return RetrieveCartState;
}());
exports.default = RetrieveCartState;
//# sourceMappingURL=RetrieveCartState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/RetrieveCart/RetrieveCartState.js
// module id = 2278
// module chunks = 8